import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {ReactComponent as ScanIcon} from "assets/img/wms/scan.svg"
import {BarCodeScannerContext} from "../../../../../contexts/barCodeScannerContext";
import {
    getWMSContainers,
    getWMSContainerWithCodeBar,
    patchWMSContainerMemberWithCodebar
} from "../../../../../api/wms/wmsContainers/wmsContainers";
import {WMSContext} from "../../../context/WMSContext";
import {WmsContainerType} from "../../../../../utils/WMSContainerType";
import WrongScanToast from "../../../../../components/WMS/WrongScanToast";
import {PackingContext} from "../PackingOrderList/PackingContext";
import Badge from "../../../../../components/Badge";
import MultiExpForceStopModal from "./MultiExpForceStopModal";

ScanWorkstationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleWorkstationClaimed: PropTypes.func.isRequired,
    handleAlreadyTakenWorkstation: PropTypes.func.isRequired,
};


function ScanWorkstationModal({open, handleClose, handleWorkstationClaimed, handleAlreadyTakenWorkstation}) {
    const {scannedString, setEnableScan} = useContext(BarCodeScannerContext)
    const {currentMember} = useContext(WMSContext)
    const {isMultiSessionPacking} = useContext(PackingContext)

    const [notPackingStation, setNotPackingStation] = useState(false)
    const [openWrongScanToast, setOpenWrongScanToast] = useState(false)
    const [stopMultiExpSession, setStopMultiExpSession] = useState(false)

    useEffect(() => {
        if (scannedString && scannedString !== "") {
            setEnableScan(false)
            getWMSContainerWithCodeBar(scannedString, false).then((container) => {
                if (WmsContainerType.PACKING_STATION !== container.type) {
                    setNotPackingStation(true)
                    setEnableScan(true)
                    return
                } else {
                    setNotPackingStation(false)
                }

                if (container.member) {
                    if (container.member.id === currentMember.id) {
                            handleWorkstationClaimed(container, container.computerId)
                    } else {
                        handleAlreadyTakenWorkstation(container)
                    }
                } else {
                    patchWMSContainerMemberWithCodebar(container.codebar, currentMember).then(() => {
                        handleWorkstationClaimed(container, container.computerId)
                    })
                }
            }).catch(() => {
                setNotPackingStation(true)
                setEnableScan(true)
                setOpenWrongScanToast(true)
            })
        }
    }, [scannedString]);

    if (stopMultiExpSession) {
        return (
            <MultiExpForceStopModal open={stopMultiExpSession} handleClose={() => setStopMultiExpSession(false)}/>
        )
    }

    return (
        <>
            {openWrongScanToast && (
                <WrongScanToast
                    open={openWrongScanToast}
                    handleClose={() => setOpenWrongScanToast(false)}
                />
            )}
            <Popup
                open={open}
                onClose={isMultiSessionPacking ? () => setStopMultiExpSession(true) : handleClose}
                title={notPackingStation ? <FormattedMessage id={"wms.packing.modal.scanWorkstation.wrong.title"} /> : <FormattedMessage id={"wms.packing.modal.scanWorkstation.title"}/>}
                subtitle={notPackingStation ? <FormattedMessage id={"wms.packing.modal.scanWorkstation.wrong.subtitle"} /> : <FormattedMessage id={"wms.packing.modal.scanWorkstation.subtitle"}/>}
                icon={<ScanIcon/>}
                isMobile
                strictOnclose
            >
                {isMultiSessionPacking && (
                    <Badge
                        size={"large"}
                        rounded
                        label={<FormattedMessage id={"wms.packing.item.multiSessionPacking.notice"}/>}
                        color={"online"}
                    />
                )}
            </Popup>
        </>
    );
}

export default ScanWorkstationModal;